const totalPriceTruncationUnit = 100;

export const calcItemPrice = (originalPrice: number, discountRate: number) => {
  const discountedPriceBydefaultDiscount = originalPrice * (discountRate / 100);
  return (
    Math.floor(
      (originalPrice - discountedPriceBydefaultDiscount) /
        totalPriceTruncationUnit
    ) * totalPriceTruncationUnit
  );
};
